<template>
    <div class="d-flex flex-column flex-root">
        <div
            class="d-flex flex-column flex-lg-row flex-row-fluid bg-white"
            id="appointment_action_wrapper"
        >
            <div
                class="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
            >
                <div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                    <div>
                        <div class="appointment-action-card">
                            <div class="text-center mb-10 mb-lg-20">
                                <div class="logo">
                                    <img :src="logoPath" alt="bookybook" />
                                </div>

                                <div
                                    v-if="state === 'loading'"
                                    class="state-block"
                                >
                                    <div class="spinner spinner-primary"></div>
                                    <h1>
                                        {{
                                            $t(
                                                "appointmentActions.approve.loading"
                                            )
                                        }}
                                    </h1>
                                </div>

                                <div
                                    v-else-if="state === 'success'"
                                    class="state-block"
                                >
                                    <svg
                                        class="result-icon success"
                                        width="64"
                                        height="64"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="11"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        />
                                        <path
                                            d="M7 12.5L10.5 16L17 8.5"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <h1>
                                        {{
                                            $t(
                                                "appointmentActions.approve.success"
                                            )
                                        }}
                                    </h1>
                                </div>

                                <div v-else class="state-block">
                                    <svg
                                        class="result-icon error"
                                        width="64"
                                        height="64"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="11"
                                            stroke="currentColor"
                                            stroke-width="2"
                                        />
                                        <path
                                            d="M8 8L16 16M16 8L8 16"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                    <h1>{{ errorMessage }}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpService from "@/core/services/http.service.js";

export default {
    name: "ApproveAppointment",
    data() {
        return {
            state: "loading",
            errorMessage: this.$t("appointmentActions.genericError"),
        };
    },
    mounted() {
        httpService
            .post("api/approve-appointment", null, {
                params: this.$route.query,
            })
            .then(() => {
                this.state = "success";
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    this.errorMessage = this.$t(
                        "appointmentActions.approve.invalidLink"
                    );
                } else {
                    this.errorMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        this.$t("appointmentActions.genericError");
                }
                this.state = "error";
            });
    },
    computed: {
        logoPath() {
            return process.env.BASE_URL + "media/logos/bb_logo.png";
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/bb-styles/scoped/appointment-actions.scss";
</style>
